import { Chip, useTheme } from "@mui/material";
import useSWR from "swr";

import CustomChip from "../components/CustomChip";
import { ECP } from "../types/ecp";
import { FetchOptions, SWRType } from "../types/global";
import { authFetcher } from "../utils/auth-fetch";

const useTag = (
  autoFetch = false,
  options: FetchOptions | null = null,
  props: Record<string, any> = {},
) => {
  const theme = useTheme();

  let swrUrl = "settings/tags";
  if (options?.fetchOne) {
    swrUrl = `settings/tags/${options.id}`;
  }

  const {
    data,
    isLoading: dataLoading,
    mutate,
    error,
  }: SWRType = useSWR(
    autoFetch ? [swrUrl, props] : null,
    ([url, queryParams]) => authFetcher("GET", url, null, queryParams),
    {
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
      onErrorRetry: (error) => {
        if (error.status === 404) return;
      },
    },
  );

  const renderAllECPTags = (ecp: ECP) => {
    return (
      <div className="flex flex-wrap gap-1 justify-center">
        {ecp?.is_vip && <Chip label="VIP" size="small" color="success" />}
        {ecp?.payment_tag?.name && (
          <CustomChip
            label={ecp?.payment_tag?.name}
            textColor={ecp?.payment_tag?.text_color_code}
            bgColor={ecp?.payment_tag?.background_color_code}
          />
        )}
        {ecp?.essilor_expert_tag?.name && (
          <CustomChip
            label={ecp?.essilor_expert_tag?.name}
            textColor={ecp?.essilor_expert_tag?.text_color_code}
            bgColor={ecp?.essilor_expert_tag?.background_color_code}
          />
        )}
        {ecp?.essilor_partner_tag?.name && (
          <CustomChip
            label={ecp?.essilor_partner_tag?.name}
            textColor={ecp?.essilor_partner_tag?.text_color_code}
            bgColor={ecp?.essilor_partner_tag?.background_color_code}
          />
        )}
        {ecp?.nikon_lenswear_partner_tag?.name && (
          <CustomChip
            label={ecp?.nikon_lenswear_partner_tag?.name}
            textColor={ecp?.nikon_lenswear_partner_tag?.text_color_code}
            bgColor={ecp?.nikon_lenswear_partner_tag?.background_color_code}
          />
        )}
        {ecp?.tags && ecp?.tags?.length > 0 && (
          <>
            {ecp?.tags?.map((tag) => (
              <CustomChip
                key={tag.id}
                label={tag.name}
                textColor={tag.text_color_code}
                bgColor={tag.background_color_code}
              />
            ))}
          </>
        )}
      </div>
    );
  };

  return {
    data,
    dataLoading,
    mutate,
    error,
    renderAllECPTags,
  };
};

export default useTag;
